import { StyleSheet, css } from 'aphrodite'
import type React from 'react'

interface SearchBarProps {
  onSearch: (searchTerm: string) => void
  placeholder?: string
}

const SearchBar: React.FC<SearchBarProps> = ({
  onSearch,
  placeholder = 'Search for Tag by ID / Location / Date',
}) => {
  return (
    <div className={css(styles.searchBar)}>
      <input
        type="text"
        placeholder={placeholder}
        onChange={(e) => onSearch(e.target.value)}
        className={css(styles.searchInput)}
      />
    </div>
  )
}

export default SearchBar

const styles = StyleSheet.create({
  searchBar: {
    marginRight: '20px',
    '@media (max-width: 1024px)': {
      width: '93%',
      marginRight: 0,
    },
  },
  searchInput: {
    padding: '10px',
    width: '300px',
    '@media (max-width: 1024px)': {
      width: '100%',
    },
    borderRadius: 8,
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    border: '1px solid #E5E7EB',
  },
})
